<template>
  <div class="video-modal" data-test-id="VideoComponent">
    <div>
      <video ref="video" muted @contextmenu="interceptContextMenu($event)" />
    </div>
    <div>
      <section v-if="!isRecording && !videoBlob">
        <b-iconstack v-if="canSwitchCamera" font-scale="3" variant="white" @click="switchCamera">
          <b-icon icon="camera" stacked variant="danger"></b-icon>
          <b-icon icon="arrow-right-short" scale="0.5" shift-v="-9" shift-h="3" stacked variant="danger"></b-icon>
          <b-icon icon="arrow-left-short" scale="0.5" shift-v="-9" shift-h="-3" stacked variant="danger"></b-icon>
        </b-iconstack>
        <b-button variant="danger" data-test-id="VideoRecordButton" @click="record">
          <i>Record</i>
        </b-button>
      </section>
      <section v-if="isRecording">
        <b-button variant="danger" data-test-id="VideoStopButton" @click="stop">
          <i>Stop</i>
        </b-button>
      </section>
      <section v-if="!isRecording && videoBlob">
        <b-button variant="danger" data-test-id="VideoRetakeButton" class="mr-2" @click="retake">
          <i>Retake</i>
        </b-button>
        <b-button variant="danger" data-test-id="VideoSendButton" @click="send">
          <i>Send Video</i>
        </b-button>
      </section>
    </div>
  </div>
</template>

<script>
import { BIcon, BIconstack } from "bootstrap-vue";

import { createMediaDevicesIterator } from "@/Case/sharedUserMediaFunctions/createMediaDevicesIterator";
import { stopAllTracks } from "@/Case/sharedUserMediaFunctions/stopAllTracks";
import { switchCamera } from "@/Case/sharedUserMediaFunctions/switchCamera";
import { CaseEvent } from "@/Case/CaseEvent";

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Video",
  components: { BIcon, BIconstack },
  props: {
    eventType: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      canSwitchCamera: true,
      currentDeviceID: "",
      isRecording: false,
      mediaStream: undefined,
      recorder: undefined,
      videoBlob: undefined,
      videoChunks: [],
    };
  },

  async mounted() {
    if ((await this.createMediaDevicesIterator()) < 2) {
      this.canSwitchCamera = false;
    }

    await this.switchCamera();
  },

  destroyed() {
    this.stopAllTracks();
  },

  methods: {
    createMediaDevicesIterator,

    stopAllTracks,

    switchCamera,

    interceptContextMenu(event) {
      event.preventDefault();
    },

    record() {
      if (navigator && navigator.mediaDevices) {
        if (!this.isRecording) {
          this.destroy();

          navigator.mediaDevices.getUserMedia(this.constraints).then((stream) => {
            let type = "video/webm";
            if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported("video/webm;codecs=h264")) {
              type = "video/webm;codecs=h264";
            }

            this.recorder = new MediaRecorder(stream, {
              mimeType: type,
            });
            this.mediaStream = stream;

            this.$refs.video.srcObject = stream;
            this.$refs.video.muted = true;
            this.$refs.video.play();

            this.recorder.ondataavailable = (e) => {
              this.videoChunks.push(e.data);
            };

            this.recorder.addEventListener("stop", () => {
              this.videoBlob = new Blob(this.videoChunks, {
                type,
              });

              if (this.$refs.video) {
                this.$refs.video.srcObject = undefined;
                this.$refs.video.src = URL.createObjectURL(new Blob(this.videoChunks));
                this.$refs.video.muted = false;
                this.$refs.video.play();
              }

              this.videoChunks = [];
              this.stopAllTracks();
              this.isRecording = false;
            });

            this.recorder.start();
            this.isRecording = true;
          });
        }
      }
    },

    destroy() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
    },

    retake() {
      this.record();
    },

    send() {
      this.$emit(CaseEvent.MODIFY, {
        eventType: this.eventType,
        id: `${this.eventType}.mp4`,
        data: this.videoBlob,
      });
      this.destroy();
    },

    stop() {
      this.recorder.stop();
    },
  },
};
</script>

<style scoped>
.video-modal {
  width: 100%;
  height: 100%;
  align-items: center;
  margin-bottom: 24px;
  z-index: 10;
}
.video-modal button {
  margin: 20px;
}
video {
  width: 100%;
}
</style>
